import SituacionLaboralForm from './SituacionLaboralForm'
export {SituacionLaboralForm}
export default SituacionLaboralForm
